import { useEffect, useState } from "react";
import api from "@/lib/api";

const B = "https://customer-assets-4nw71qhi.emergentagent.net/job_destination-runs/artifacts/";

export const PARTNERS = [
  { name: "Tourism & Civil Aviation Dept. of Sikkim", logo: "/partners/sikkim-tourism.png", url: "https://sikkimtourism.gov.in" },
  { name: "Meghalaya State Tourism", logo: "/partners/meghalaya-tourism.png", url: "https://meghalayatourism.in" },
  { name: "Karbi Anglong Tourism", logo: "/partners/karbi-anglong-tourism.png", url: "https://karbianglongtourism.com/" },
  { name: "Arunachal Pradesh Tourism", logo: "/partners/arunachal-tourism.png", url: "https://arunachaltourism.com" },
  { name: "State Bank of India", logo: "/partners/sbi.png", url: "https://sbi.co.in" },
  { name: "Punjab National Bank", logo: "/partners/pnb.png", url: "https://pnbindia.in" },
  { name: "IRIS Multi Speciality Hospital", logo: "/partners/iris-hospital.png", url: "https://irishealthservices.com" },
  { name: "Awesome Assam (Dept. of Tourism)", logo: "/partners/awesome-assam.png", url: "https://tourism.assam.gov.in" },
  { name: "Incredible India", logo: "/partners/incredible-india.png", url: "https://incredibleindia.gov.in" },
];

export default function PartnersMarquee({ eyebrow = "OUR PARTNERS & COLLABORATORS", title = "Trusted By Destinations & Brands Across India" }) {
  const [partners, setPartners] = useState(PARTNERS);
  useEffect(() => {
    api.get("/partners").then((r) => { if (r.data?.length) setPartners(r.data); }).catch(() => {});
  }, []);
  return (
    <section data-testid="partners-marquee" className="overflow-hidden border-y border-brand-line bg-brand-surface/30 py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="eyebrow text-center">{eyebrow}</p>
        <h3 className="mt-2 text-center font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">{title}</h3>
      </div>
      <div className="group relative mt-8">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-brand-ink to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-brand-ink to-transparent" />
        <div className="flex w-max animate-marquee gap-5 group-hover:[animation-play-state:paused]">
          {[...partners, ...partners].map((p, i) => (
            <a
              key={i}
              data-testid={`partner-logo-${i % partners.length}`}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              title={p.name}
              className="flex h-28 w-72 shrink-0 items-center justify-center rounded-xl border border-brand-line bg-white px-7 transition-[transform,box-shadow] duration-300 hover:scale-105 hover:shadow-[0_0_24px_rgba(24,168,221,0.25)]"
            >
              {p.logo ? (
                <img src={p.logo} alt={p.name} className="max-h-20 w-auto max-w-full object-contain" loading="lazy" />
              ) : (
                <span className="text-center font-display text-base font-bold uppercase leading-tight tracking-wide text-brand-ink">
                  {p.name}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
      <p className="mx-auto mt-6 max-w-7xl px-4 text-center font-mono text-[10px] tracking-[0.15em] text-slate-600 sm:px-6">
        LOGOS REPRESENT PAST AND PRESENT EVENT PARTNERS, SUPPORTERS AND COLLABORATORS OF SPORTIVE EVENTS.
      </p>
    </section>
  );
}
